<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>海關研學</el-breadcrumb-item>
                <el-breadcrumb-item>列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



      <div class="content">

        <div>
          <div class="data-box">
            <div class="tab-data" style="margin-top:20px;">
              <template>
                <div style="min-height:500px;">
                  <el-table
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"
                  style="margin-left:50px; width: 1100px;">
                  <el-table-column
                    prop="gxsd_pubulish_serial"
                    label="序號"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    prop="proj_title"
                    label="項目名稱"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="proj_detail"
                    label="項目詳情"
                    width="450">
                  </el-table-column>
                  <el-table-column
                    prop="proj_datetime"
                    label="時間"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="proj_author"
                    label="作者"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="gxsd_port_name"
                    label="瀏覽量"
                    width="150">
                  </el-table-column>
                </el-table>

                </div>
                

                <div style="width:1150px; margin-bottom:10px;" >
                  <div style="text-align: right;margin-top: 15px;">
                  <el-pagination
                    background
                    :current-page="currentpage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pagesize"
                    :data="tableData"
                    :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor"
                    layout="total,sizes,prev, pager, next"
                    :total="totalcount"
                    @current-change="current_change"
                    @size-change="size_change">
                  </el-pagination>
                </div>

                </div>            
              </template>

            </div>

          </div>
        </div>

      </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      totaldata:'99999',
      cztype:'new',
      czlist:[],
      tableData:[],

      currrentpage:1,
      pageSize:20,
      totalcount:100,
      
    };
  },
  methods: {
    current_change(val){
        this.currrentpage=val;
        this.retrieval();
      },
    size_change(val){
      this.pageSize=val;
      this.retrieval();
       //this.submitform();
    },
    //点击搜索按钮
    btnsearch(){

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
  },
  created() {
    //获取当前条目ID号
    //this.cztype = this.$route.params.tab;

    this.$http
      .get(`${this.$store.state.baseurl}/api/hgsub/getsublist`)
      .then((res) => {
        let json=JSON.parse(res.data);
        this.tableData=json.data;
        //console.log(this.tableData);
      });
  },
};
</script>



<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.my-table{
  margin-left: auto;
  margin-right: auto;
  .my-tbody{
    display: table-row-group;
    vertical-align: middle;
    width: 1000px;
    
    tr {
        display: table-row;
        vertical-align: inherit;
        th {
          display: table-cell;
          vertical-align: inherit;
          font-weight: bold;
          text-align: left;
          height: 50px;
          border: none;
          background-color: #d4c9bc;
      }
        td {
          display: table-cell;
          vertical-align: inherit;
          text-align: left;
          height:80px;
      }
    }

  }
}





</style>